<div class="modal-header border-0">
  <button
    type="button"
    class="btn-close"
    [gptDataTrack]="
      analyticsId ? analyticsId + '-questionnaire-close' : null
    "
    (click)="close()"
  >
    <i class="gpicon-close"></i>
  </button>
</div>

<div class="modal-body gmt-32 gmt-sm-0">
  <ng-container *ngIf="selectedQuestion">
    <ng-container [ngSwitch]="selectedQuestion.qid">
      <ng-container
        *ngSwitchCase="pageId.start"
        [ngTemplateOutlet]="welcomePage"
        [ngTemplateOutletContext]="{ data: selectedQuestion }"
      ></ng-container>
      <ng-container
        *ngSwitchCase="pageId.complete"
        [ngTemplateOutlet]="completedPage"
        [ngTemplateOutletContext]="{ data: selectedQuestion }"
      ></ng-container>
      <ng-container *ngSwitchDefault>
        <ng-container
          [ngTemplateOutlet]="
            isSaveStep && selectedQuestion.type === controlTypes.HEAD
              ? lastStepTpl
              : questionTpl
          "
          [ngTemplateOutletContext]="{ data: selectedQuestion }"
        >
        </ng-container>
        <ng-template #questionTpl let-data="data">
          <p class="p5-semibold text-muted gmb-8">
            {{ questionIndex }}/{{ filteredQuestionsLength }}
          </p>

          <ng-container
            [ngTemplateOutlet]="
              selectedQuestion.type === controlTypes.HEAD
                ? headerTitle
                : questionTitle
            "
            [ngTemplateOutletContext]="{
              title: selectedQuestion.text,
              description: selectedQuestion.description
            }"
          >
          </ng-container>

          <p
            *ngIf="selectedQuestion.subHeader"
            class="p4-regular text-muted gpt-8 m-0"
          >
            {{ selectedQuestion.subHeader }}
          </p>

          <p
            *ngIf="selectedQuestion.description"
            class="p4-regular text-muted gpt-8 m-0"
          >
            {{ selectedQuestion.description }}
          </p>

          <form [formGroup]="form" class="gmt-24 gmb-80 gmb-md-32">
            <ng-container [ngSwitch]="selectedQuestion.type">
              <ng-container *ngSwitchCase="controlTypes.TEXTBOX">
                <gpu-form-field>
                  <input
                    type="text"
                    gpuInput
                    [formControlName]="selectedQuestion.qid"
                  />
                </gpu-form-field>
              </ng-container>

              <ng-container *ngSwitchCase="controlTypes.WIDGET">
                <ng-container
                  *ngIf="selectedQuestion.widgetType === widgetTypes.FIELD"
                >
                  <gpu-form-field>
                    <gpu-filterable-select [formControl]="control">
                      <gpu-option
                        *ngFor="let option of getFieldOptions()"
                        [value]="option"
                      >
                        {{ option }}
                      </gpu-option>
                    </gpu-filterable-select>
                  </gpu-form-field>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="selectedQuestion.options">
                <gpu-radio-group
                  *ngSwitchCase="
                    selectedQuestion.type == controlTypes.YESNO ||
                    selectedQuestion.type == controlTypes.RADIO
                      ? selectedQuestion.type
                      : null
                  "
                  [formControl]="control"
                >
                  <gpu-radio-button
                    *ngFor="let option of getAnswers(selectedQuestion?.options)"
                    class="w-100 gmy-12"
                    [id]="selectedQuestion.qid + option"
                    [value]="option"
                  >
                    {{ option }}
                  </gpu-radio-button>
                </gpu-radio-group>

                <ng-container *ngSwitchCase="controlTypes.CHECKBOX">
                  <ng-container [formGroup]="control">
                    <div
                      *ngFor="
                        let option of getAnswers(selectedQuestion?.options)
                      "
                      class="gmt-12 gmb-24"
                    >
                      <gpu-checkbox
                        class="gmt-12"
                        [formControl]="getOption(option)"
                        [checked]="getOption(option).value"
                      >
                        <span class="p3-regular d-flex align-self-center">
                          {{ option }}
                        </span>
                      </gpu-checkbox>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </form>

          <app-form-page-footer class="bg-white">
            <div class="d-sm-inline-flex d-flex">
              <button
                *ngIf="this.questions[0].qid != selectedQuestion.qid"
                type="button"
                class="text-primary bg-transparent gp-12 border-0"
                [gptDataTrack]="
                  analyticsId ? analyticsId + '-questionnaire-previous' : null
                "
                (click)="next(-1)"
              >
                <i class="gpicon-back-fat"></i>
              </button>

              <button
                class="gbtn-1 gbtn-sq b2-semibold w-100 gml-24 gml-sm-12"
                [gptDataTrack]="
                  analyticsId ? analyticsId + '-questionnaire-next' : null
                "
                [disabled]="!control.valid"
                (click)="next()"
              >
                {{ (isSaveStep ? 'JOTFORM.COMPLETE' : 'NEXT') | translate }}
              </button>
            </div>
          </app-form-page-footer>
        </ng-template>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<ng-template #headerTitle let-title="title">
  <h4 class="h4-bold w-100" [innerHTML]="title"></h4>
</ng-template>

<ng-template #questionTitle let-title="title">
  <h4 class="h4-bold m-0" [innerHTML]="title"></h4>
</ng-template>

<ng-template #welcomePage let-data="data">
  <div class="text-center">
    <h4 class="h4-bold">{{ data.title }}</h4>
    <p class="p4-regular text-muted">{{ data.subTitle }}</p>
    <app-form-page-footer class="bg-white text-center">
      <button
        class="gbtn-1 gbtn-sq b2-semibold gmt-32"
        [gptDataTrack]="
          analyticsId ? analyticsId + '-questionnaire-start' : null
        "
        (click)="start()"
      >
        {{ data.buttonText }}
      </button>
    </app-form-page-footer>
  </div>
</ng-template>

<ng-template #completedPage let-data="data">
  <div class="text-center">
    <h4 class="h4-bold">{{ data.title }}</h4>
    <p class="p4-regular text-muted">{{ data.subTitle }}</p>
    <app-form-page-footer class="bg-white text-center">
      <button
        class="gbtn-1 gbtn-sq b2-semibold gmt-32"
        [gptDataTrack]="
          analyticsId ? analyticsId + '-questionnaire-close' : null
        "
        (click)="modal.dismiss()"
      >
        {{ 'CLOSE' | translate }}
      </button>
    </app-form-page-footer>
  </div>
</ng-template>

<ng-template #lastStepTpl let-data="data">
  <div class="text-center">
    <img
      class="img-fluid"
      src="/assets/images/success.svg"
      alt="success"
      width="96"
    />

    <h6 *ngIf="selectedQuestion.subHeader" class="h6-bold gpt-16 m-0">
      {{ data.text }}
    </h6>

    <p
      *ngIf="selectedQuestion.subHeader"
      class="p2-regular text-secondary gpt-16 m-0"
    >
      {{ data.subHeader }}
    </p>

    <p
      *ngIf="selectedQuestion.description"
      class="p2-regular text-secondary gpt-16 m-0"
    >
      {{ data.description }}
    </p>
    <app-form-page-footer class="bg-white text-center gpt-32">
      <button
        type="button"
        class="gbtn-2 gbtn-sq b2-semibold"
        [gptDataTrack]="
          analyticsId ? analyticsId + '-questionnaire-back' : null
        "
        (click)="next(-1)"
      >
        {{ 'BACK' | translate }}
      </button>

      <button
        class="gbtn-1 gbtn-sq b2-semibold gml-24 gml-sm-12"
        [disabled]="!control.valid"
        [gptDataTrack]="
          analyticsId ? analyticsId + '-questionnaire-complete' : null
        "
        (click)="saveAnswer()"
      >
        {{ 'JOTFORM.COMPLETE' | translate }}
      </button>
    </app-form-page-footer>
  </div>
</ng-template>
